import Service from "./service.abstract";

export default class CheckMailNewService extends Service {
  constructor(url: string) {
    super();

    this.url = url;
    this.errorTopic = "service.error.checkmailnew";
  }
}
